<template>
  <article>
    <v-snackbar v-model="snackBar" :timeout="snackBarTimeout" color="error">
      {{ errorMessage }}
      <v-btn color="white" text @click="snackBar = false">Zapri</v-btn>
    </v-snackbar>

    <v-container fluid>
      <v-row justify="center" class="mb-1 mb-sm-5">
        <img src="/img/logo-192w.png" />
      </v-row>

      <v-row class="mb-1 mb-sm-5" justify="center">
        <v-col cols="12" sm="8" lg="3" class="text-center">
          <h3>Prijava v aplikacijo</h3>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="8" md="4" lg="3">
          <v-card
            class="login pa-lg-4 pa-2"
            :elevation="$vuetify.breakpoint.smAndUp > 0 ? 1 : 0"
          >
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="E-pošta"
                type="text"
                v-model="email"
                flat
                required
                placeholder="Vaš email"
                prepend-icon="mdi-email"
                ref="email"
              />
              <v-text-field
                label="Geslo"
                type="password"
                v-model="password"
                flat
                required
                placeholder="Hudo geslo ;)"
                prepend-icon="mdi-lock"
                ref="password"
              />
              <v-btn color="primary" @click="doLogin">
                <v-icon :class="submitSpin" left>{{ submitIcon }}</v-icon
                >Prijava
              </v-btn>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4" lg="3" class="text-right">
          <!-- <router-link to="/password">Pozabljeno geslo</router-link> -->
        </v-col>
      </v-row>
    </v-container>
  </article>
</template>

<script>
var errorMessages = [];
// indexed by code, first one is the message, second the input to focus on after error

errorMessages["auth/wrong-credentials"] = ["Napačen email ali geslo", "email"];

export default {
  data: () => ({
    valid: false,
    email: "",
    password: "",
    submitIcon: "mdi-location-enter",
    submitSpin: "",
    errorMessage: "",
    snackBar: false,
    snackBarTimeout: 10000,
  }),
  methods: {
    doLogin() {
      this.submitIcon = "mdi-loading";
      this.submitSpin = "mdi-spin";

      const saveFormFields = { email: this.email, password: this.password };
      // console.log("trying to log in ");
      delete this.$axios.defaults.headers["Authorization"];

      // console.log(this.$axios.defaults.headers);

      const that = this;

      this.$axios
        .post("/login", saveFormFields)
        .then(function (response) {
          that.$router.replace("/");
          // console.log("got credentials ", response);
          that.$axios.defaults.headers.Authorization =
            "Bearer " + response.data.token;

          const user = response.data.user;
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", JSON.stringify(user));

          that.$store.dispatch("setUserData", user);
          that.$router.replace({ name: "Home" });
        })
        .catch((error) => {
          this.submitIcon = "mdi-location-enter";
          this.submitSpin = "";
          this.snackBar = true;
          const err = error.response.data; // formatted as "message" and "code"
          var m = errorMessages[err.code][0];

          this.errorMessage = m || err.message + ` (${err.code})`;

          var refEl = errorMessages[err.code][1];
          var el = that.$refs[refEl];
          var elInput = el.$el.querySelectorAll("input")[0]; // find actual input within component
          elInput.setSelectionRange(0, elInput.value.length);
          elInput.focus();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
article {
  width: 100vw;
  height: 80%;
  display: grid;
  grid-template-columns: 1fr;
  align-content: center;
}
</style>
